module.exports = __webpack_public_path__ + "img/375.30743b9e.jpg";